<div class="empty-buildings-popup">
  <div class="popup-contents">
    <button class="close-button" *ngIf="!hideClose">
      <img class="x-icon popup-close" alt="close-icon" src="./assets/icons/close-icon-gray.svg" (click)="closeModal()" />
    </button>
    <img alt="thumbnail-img" class="icon" src="./assets/icons/unknown_bldg.png" />
    <p class="message" *ngIf="hideClose">
      {{ 'module.efficiencyAnalysis.undefinedBuildingsPopup.messageTextScenario1' | translate }}
    </p>
    <p class="message" *ngIf="!hideClose">
      {{ 'module.efficiencyAnalysis.undefinedBuildingsPopup.messageTextScenario2' | translate }}
    </p>
    <button class="btn btn-outline-primary" (click)="goToMap()">
      {{ 'module.efficiencyAnalysis.undefinedBuildingsPopup.buttonText' | translate }}
    </button>
  </div>
</div>
